import { Address, AllClientAddresses, IPersonalAddressState } from '@interfaces';
import { Action, createReducer, on } from '@ngrx/store';

import {
  ResetMfePersonalAddress,
  UpdateMfePersonalAddress,
  UpdateMfePersonalAddressFromGetData,
  UpdateMfePersonalAddressIsContinueConfirmed,
  UpdateMfePersonalAddressValidationStatus,
} from '../../actions/personal-info-address/personal-info-address.actions';
import { StartOverStateCleared } from '../../actions/start-over/start-over.actions';

export interface MfePersonalAddressState {
  personalAddress: IPersonalAddressState;
}

export const initialAddress: Address = {
  street: '',
  city: '',
  zipCode: '',
  state: '',
};

export const initialClientAddresses: AllClientAddresses = {
  mailingAddressesList: [],
  streetAddressesList: [],
};

export const initialPersonalAddressState: IPersonalAddressState = {
  mailingAddress: { ...initialAddress },
  streetAddress: { ...initialAddress },
  isStreetAddressSame: true,
  validationStatus: '',
  showValidation: false,
  clientAddresses: { ...initialClientAddresses },
  isClientAddressesProcessing: false,
  isClientAddressesLoaded: false,
  mailingAddressDropdown: '',
  streetAddressDropdown: '',
  isContinueConfirmed: false,
};

export const initialState: MfePersonalAddressState = {
  personalAddress: { ...initialPersonalAddressState },
};

const mfePersonalAddressReducer = createReducer(
  initialState,
  on(
    UpdateMfePersonalAddress,
    (state, { payload }): MfePersonalAddressState => ({
      ...state,
      personalAddress: { ...payload },
    }),
  ),
  on(
    UpdateMfePersonalAddressValidationStatus,
    (state, { payload }): MfePersonalAddressState => ({
      ...state,
      personalAddress: {
        ...state.personalAddress,
        validationStatus: payload,
      },
    }),
  ),
  on(UpdateMfePersonalAddressFromGetData, (state, { payload }): MfePersonalAddressState => {
    return {
      ...state,
      personalAddress: {
        ...state.personalAddress,
        ...payload.personalAddress,
        validationStatus: payload.validationStatus,
      },
    };
  }),
  on(
    UpdateMfePersonalAddressIsContinueConfirmed,
    (state, { payload }): MfePersonalAddressState => ({
      ...state,
      personalAddress: {
        ...state.personalAddress,
        isContinueConfirmed: payload,
      },
    }),
  ),
  on(
    ResetMfePersonalAddress,
    (): MfePersonalAddressState => ({
      ...initialState,
      personalAddress: { ...initialPersonalAddressState },
    }),
  ),
  on(
    StartOverStateCleared,
    (): MfePersonalAddressState => ({
      ...initialState,
      personalAddress: { ...initialPersonalAddressState },
    }),
  ),
);

export function reducer(state: MfePersonalAddressState | undefined, action: Action) {
  return mfePersonalAddressReducer(state, action);
}
